import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-despacho-recorrido",
  templateUrl: "./despacho-recorrido.component.html",
  styleUrls: ["./despacho-recorrido.component.scss"]
})
export class DespachoRecorridoComponent implements OnInit {
  constructor() {}

  optionsChofer: Array<any> = [];
  ngOnInit() {
    this.optionsChofer = [
      { value: "1", label: "Juan Pérez" },
      { value: "2", label: "Pedro Pérez" },
      { value: "3", label: "Ramón Pérez" }
    ];
  }
}
